<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.go(-1)"
        >上一页</a-breadcrumb-item
      >
      <a-breadcrumb-item>医生详情</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="doctor">
      <!--头像-->
      <div class="img">
        <img
          v-if="doctorInfo.YISHENGXM != '普通' && doctorInfo.YISHENGXM"
          src="@/assets/img/doc.png"
          alt=""
        />
        <img v-else src="@/assets/img/ptmz.png" alt="" />
      </div>

      <!--头像-->

      <div class="list-pro-name">
        <div class="item-name">
          <span class="item-name-text">{{
            doctorInfo.YISHENGXM || "普通门诊"
          }}</span>
          <span class="item-name-job">{{ doctorInfo.YISHENGZC }}</span>
        </div>
        <div class="item-department-name">
          {{ doctorInfo.KESHIMC }}
        </div>
        <div class="about" v-if="doctorInfo.YISHENGJS">
          <PanelTitle title="简介"></PanelTitle>
          <p>
            {{ doctorInfo.YISHENGJS }}
          </p>
        </div>
      </div>
    </div>
    <div class="appointment-time">
      <PanelTitle :title="`${YINGYONGMC}`" class="title-ment"></PanelTitle>
      <div class="loading-x" v-if="loading">
        <a-spin  />
      </div>
      <div v-if="scheduleList.length > 0">
        <div v-for="(item, i) in scheduleList" :key="i">
          <a-card hoverable>
            <div class="week">
              <div class="week-now">{{ item.GUAHAOBC | dutyTypeFilter2 }}</div>
              <div class="week-now-time">
                <div class="item">
                  <span class="item-time"
                    >{{ item.PAIBANRQ }}
                    {{ item.PAIBANRQ | showWeekFilter }}</span
                  >
                  <span class="item-price">
                    <span class="fontColor1"
                      >挂号费用：{{ item | GHFFilter }}元</span
                    >
                  </span>
                  <span class="item-btn">
                    <!--已满-->
                    <a-button
                      v-if="
                        (item.GUAHAOBC == '0' &&
                          item.SHANGWUSYH != '有号' &&
                          Number(item.SHANGWUSYH) <= 0) ||
                        (item.GUAHAOBC == '1' &&
                          item.XIAWUSYH != '有号' &&
                          Number(item.XIAWUSYH) <= 0)
                      "
                      :disabled="true"
                      >已满
                    </a-button>
                    <!--有号-->
                    <a-button
                      v-else-if="
                        (item.GUAHAOBC == '0' && item.SHANGWUSYH == '有号') ||
                        (item.GUAHAOBC == '1' && item.XIAWUSYH == '有号')
                      "
                      type="primary"
                      @click="showModal(item)"
                      >有号
                    </a-button>
                    <!--剩余号源-->
                    <a-button
                      v-if="
                        (item.GUAHAOBC == '0' &&
                          item.SHANGWUSYH != '有号' &&
                          Number(item.SHANGWUSYH) > 0) ||
                        (item.GUAHAOBC == '1' &&
                          item.XIAWUSYH != '有号' &&
                          Number(item.XIAWUSYH) > 0)
                      "
                      type="primary"
                      @click="showModal(item)"
                      >余{{
                        item.GUAHAOBC == "0" ? item.SHANGWUSYH : item.XIAWUSYH
                      }}
                    </a-button>
                  </span>
                </div>
              </div>
            </div>
          </a-card>
          <div class="line"></div>
        </div>
      </div>
      <div v-if="isNo">
        <a-empty description="暂无排号" />
      </div>
    </div>

    <!--号源-->
    <a-modal
      wrapClassName="modalstyle"
      v-model="visible"
      :title="modalTitle"
      :footer="null"
      width="50%"
    >
      <div class="loading-x source-span" v-if="hLoading">
        <a-spin  />
      </div>
      <section v-if="sourceList && sourceList.length > 0" class="source-span">
        <span
          class="item-btn-time"
          v-for="(item, index) in sourceList"
          :key="index"
        >
          <span class="time">{{ item.GUAHAOXH }}号</span>
          <span class="time"> {{ item.JIUZHENSJ }}</span>
          <a-button type="primary" @click="doConfirmation(item)"
            >预约
          </a-button>
        </span>
      </section>
      <a-empty v-if="isNoH" description="暂无排号" class="auto-m" />
    </a-modal>
  </div>
</template>
  
  <script>
import PanelTitle from "@/components/panel-title";
import {
  queryDoctorScheduleInfoV2,
  querySourceInfoV2,
} from "@/api/registration";
import base from "@/assets/base/base.js";
export default {
  components: {
    PanelTitle,
  },
  data() {
    return {
      isNoH: false,
      hLoading: false,
      loading: false,
      isNo: false,
      modalTitle: "",
      loading: false,
      visible: false,
      visible1: false,
      GUAHAOBC: "",
      doctorInfo: {},
      scheduleList: [],
      sourceList: [],
      YINGYONGMC: "", //院区名称
    };
  },
  watch: {
    "$route.query": {
      handler(val) {
        this.doctorInfo = JSON.parse(
          sessionStorage.getItem("currentDoctorDetail")
        );
        this.YINGYONGMC = decodeURIComponent(val.YINGYONGMC);
        this.dateList = base.getSevenYMD(new Date());
        this.getData();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    onImgError() {
      this.$set(this.doctorInfo, "headerImg", require("@/assets/img/doc.png"));
    },
    //获取排班情况
    async getData() {
      this.loading = true;
      this.isNo = false;
      const params = {
        GUAHAOFS: "2",
        KESHIDM: this.$route.query.KESHIDM, //科室编号
        PAIBANRQ: this.dateList[0], //排班日期
        YISHENGDM: this.$route.query.YISHENGDM, //医生代码
        JIESHURQ: this.dateList[this.dateList.length - 1], //结束日期
        ZHIDINGKSBZ: 1, //指定科室标志,传1不取相关联的上级业务科室号源
        YINGYONGMC: this.YINGYONGMC, //院区名称
        YINGYONGID: this.$route.query.YINGYONGID, //院区id
      };
      const { code, data } = await queryDoctorScheduleInfoV2(params);
      this.loading = false;
      if (code == 200) {
        //过滤停诊
        this.scheduleList = data.filter((e) => {
          return (
            (e.GUAHAOBC == "0" && e.SHANGWUXH != -1) ||
            (e.GUAHAOBC == "1" && e.XIAWUXH != -1)
          );
        });
        //排序
        this.scheduleList
          .sort((a, b) => {
            return Number(a.GUAHAOBC) - Number(b.GUAHAOBC);
          })
          .sort((a, b) => {
            return (
              base.getTimestamp(a.PAIBANRQ) - base.getTimestamp(b.PAIBANRQ)
            );
          });
        if (this.scheduleList.length <= 0) {
          this.isNo = true;
        } else {
          this.isNo = false;
        }
      } else {
        this.isNo = true;
        this.scheduleList = [];
      }
    },
    //确认预约
    doConfirmation(e) {
      let data = {
        YINGYONGMC: this.YINGYONGMC, //院区名称
        YINGYONGID: this.$route.query.YINGYONGID, //院区id
        KESHIDM: e.KESHIID, //科室代码
        GUAHAOXH: e.GUAHAOXH, //挂号序号
        RIQI: e.RIQI, //当日排班ID
        JIUZHENSJ: e.JIUZHENSJ, //就诊时间
        ...this.confirmInfo,
      };

      sessionStorage.setItem("confirmInfo", JSON.stringify(data));
      this.$router.push({
        path: "/confirmationV2",
      });
    },

    //获取号源信息
    async showModal(item) {
      //上午
      if (item.GUAHAOBC == 0) {
        if (Number(item.SHANGWUSYH) <= 0 && item.SHANGWUSYH != "有号") {
          this.$message.warning("号源已满，请选择其他时间");
          return;
        }
      }
      //下午
      else if (item.GUAHAOBC == 1) {
        if (Number(item.XIAWUSYH) <= 0 && item.XIAWUSYH != "有号") {
          this.$message.warning("号源已满，请选择其他时间");
          return;
        }
      }
      this.confirmInfo = {
        ...item,
      };

      this.GUAHAOBC = item.GUAHAOBC;

      this.modalTitle = `${item.PAIBANRQ} ${
        item.GUAHAOBC == 0 ? "上午" : "下午"
      }`;

      this.visible = true;

      const params = {
        GUAHAOFS: "2", //挂号方式 1.挂号 2.预约
        KESHIDM: item.KESHIDM, //科室代码
        YISHENGDM: item.YISHENGDM, //医生代码
        RIQI: item.PAIBANRQ, //日期
        GUAHAOBC: item.GUAHAOBC, //挂号班次 0.上午 1.下午 空.全部
        YINGYONGMC: this.YINGYONGMC, //院区名称
        YINGYONGID: this.$route.query.YINGYONGID, //院区id
      };
      this.hLoading = true;
      this.isNoH = false;
      this.sourceList = [];
      const { code, data } = await querySourceInfoV2(params);
      this.hLoading = false;
      if (code == 200) {
        //过滤已挂号
        this.sourceList = data.filter((e) => e.HAOYUANZT == "0");
        if (this.sourceList.length <= 0) {
          this.isNoH = true;
        } else {
          this.isNoH = false;
        }
      } else {
        this.isNoH = true;
        this.sourceList = [];
      }
    },
  },
  created() {},
};
</script>
  
  <style lang="scss" scoped>
.auto-m {
  margin: auto;
}
.auto-p {
  margin: auto;
  position: relative;
  left: 55%;
}

.line {
  height: 4px;
}

.week {
  display: flex;
  position: relative;
  width: 100%;

  .week-now {
    width: 50px;
    background-color: #f6f6f6;
    font-size: 16px;
    color: #3f86ff;
    padding: 0 5px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .week-now-time {
    // width: 873px;
    flex: 1;
    .item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 12px 32px;

      > span {
        font-size: 14px;
      }
      .item-time {
        font-weight: bold;
      }
      .item-price {
        flex: 1;
        padding: 0 20px;
        box-sizing: border-box;
        span {
          margin-right: 20px;
        }
      }
    }
  }
}

.fontColor1 {
  color: #fe695c;
  font-size: 14px;
  padding: 0 5px;
}

.fontColor {
  color: #3f86ff;
  font-size: 14px;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.container {
  .doctor {
    margin-top: 20px;
    box-sizing: border-box;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 30px;
    cursor: pointer;
    .img {
      width: 60px;
      height: 60px;
      margin-right: 12px;
      img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
    }

    .list-pro-name {
      flex: 1;
      .item-name {
        margin: 2px 0;
      }

      .item-name {
        font-size: 14px;

        &-text {
          font-size: 20px;
          color: #333;
        }

        &-job {
          color: #333;
          padding: 0 10px;
        }
      }

      .item-department-name {
        margin-top: 4px;
        color: #666;
      }

      .about,
      .skilled {
        margin-top: 20px;

        p {
          color: #8e8e8e;
          padding-left: 6px;
        }
      }
    }
  }

  .appointment-time {
    padding-left: 8px;

    .title-ment {
      margin: 20px 0;
    }
  }
}

/deep/ .modalstyle {
  .ant-modal-body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 600px;
    overflow-y: auto;

    .source-span {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
    }

    > span {
      width: 45%;
    }

    .item-btn-time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 12px;
      // width: 210px;
      // box-sizing: border-box;
      border-bottom: 1px solid #faf7fa;

      .time {
        font-size: 14px;
        margin-right: 10px;
        width: 80px;
        text-align: center;
      }
      .time:first-child {
        width: 40px;
      }
    }
  }
}
/deep/ .modalstyle1 {
  .ant-modal-body {
    display: flex;
    justify-content: center;
  }
}
.loading-x {
  text-align: center;
}
</style>
  